import React, { useState } from 'react';
import { Box, TextField, Button } from '@mui/material';
import { useMutation, gql } from '@apollo/client';

const INITIATE_SHOPIFY_OAUTH = gql`
  mutation InitiateShopifyOAuth($shopDomain: String!) {
    initiateShopifyOAuth(shopDomain: $shopDomain) {
      authUrl
    }
  }
`;

interface ShopifyConnectionFormProps {
  onSubmit: (shopDomain: string) => void;
  onCancel: () => void;
}

const ShopifyConnectionForm: React.FC<ShopifyConnectionFormProps> = ({ onSubmit, onCancel }) => {
  const [shopDomain, setShopDomain] = useState<string>('');
  const [initiateShopifyOAuth] = useMutation(INITIATE_SHOPIFY_OAUTH);


  const handleOAuth = async () => {
    onSubmit("test");
    try {
      const { data } = await initiateShopifyOAuth({
        variables: { shopDomain },
      });
      console.log(`Redirecting to: ${data.initiateShopifyOAuth.authUrl}`);
      window.location.href = data.initiateShopifyOAuth.authUrl;
    } catch (error) {
      console.error('Error initiating OAuth process:', error);
    }
  };

  return (
    <Box>
      <TextField
        label="Shop Domain"
        variant="outlined"
        fullWidth
        value={shopDomain}
        onChange={(e) => setShopDomain(e.target.value)}
        margin="normal"
      />
      <Box display="flex" justifyContent="space-between" mt={2}>
        <Button variant="contained" color="primary" onClick={handleOAuth}>
          Connect to Shopify
        </Button>
        <Button variant="contained" onClick={onCancel}>
          Cancel
        </Button>
      </Box>
    </Box>
  );
};

export default ShopifyConnectionForm;
